/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Form, Input, message, Row, Typography } from "antd";
import { Auth } from "aws-amplify";
import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FormItemRequiredRule } from "../../Utility/Constants";
import AuthContainer from "./AuthContainer";
import { decrypt } from "Utility/Common/Methods";

function VerifyEmail(props) {
  const location = useLocation();
  const navigate = useNavigate();

  const [form] = Form.useForm();

  const [isLoading, setisLoading] = useState(false);
  const [showEmail, setShowEmail] = useState("");

  useEffect(() => {
    let code = location?.search?.split("code=")?.[1]?.split("+email=")?.[0];
    let email = location?.search?.split("email=")?.[1];
    setShowEmail(location?.state?.email);

    if (code && email) {
      handleSubmit({ email, code });
      return;
    }

    if (location?.state?.email) {
      form.setFieldsValue({ email: location?.state?.email });
    } else {
      navigate("/");
    }
  }, [location]);

  const handleSubmit = async (data) => {
    let UserCredentials = {
      email: location?.state?.email ?? data?.email,
      password: location?.state?.password,
    };

    let localItem = localStorage.getItem("cache");
    if (localItem && localItem?.length > 0) {
      let jsonString = decrypt(localItem, process.env.REACT_APP_SECUTRY_KEY);
      try {
        let credentials = JSON.parse(jsonString);
        UserCredentials.password = credentials.password;
        UserCredentials.email = credentials.email;
        localStorage.removeItem("cache");
      } catch (error) {
        console.log(error);
      }
    }

    setisLoading(true);
    try {
      await Auth.confirmSignUp(showEmail, String(data?.code));
      message.success("Email Verified!!");

      navigate("/login", {
        state: {
          ...UserCredentials,
          directLogin: Boolean(UserCredentials?.password),
        },
      });
      setisLoading(false);
    } catch (error) {
      console.log(error, "verify email error");
      setisLoading(false);
      message.error(error?.message);
    }
  };

  const handleResendCode = async () => {
    setisLoading(true);

    let email = form.getFieldValue("email");
    try {
      await Auth.resendSignUp(email);
      message.success("A new confirmation code has been sent.");
      setisLoading(false);
    } catch (error) {
      console.log("error signing up:", error);
      message.error(error.message);
      setisLoading(false);
    }
  };

  return (
    <AuthContainer type={"verify-email"}>
      <p className="text-slate-500 text-sm">
        We have sent an email to <span className="font-bold">{showEmail}</span>
        please verify it.
      </p>
      <Form
        onFinish={handleSubmit}
        form={form}
        layout="vertical"
        requiredMark={false}
        name="login"
        initialValues={{ remember: true }}
        className="space-y-6 text-center"
      >
        <Form.Item name={"code"} rules={[FormItemRequiredRule]}>
          <Input.OTP length={6} className="input-border" variant="filled" />
        </Form.Item>

        <Form.Item>
          <Row justify={"center"}>
            <Button
              htmlType="submit"
              loading={isLoading}
              type="primary"
              className="w-full rounded-lg "
            >
              Verify!
            </Button>
          </Row>
        </Form.Item>
      </Form>

      <div className="text-center">
        <Link to="/login" className="text-sm hover:underline">
          Already Verified ?
        </Link>
      </div>

      <div className="w-80">
        <Typography.Text
          className="text-primary cursor-pointer"
          onClick={handleResendCode}
        >
          Resend Code
        </Typography.Text>
      </div>
    </AuthContainer>
  );
}

export default VerifyEmail;
